import { Component, EnvironmentInjector, Input, Output, EventEmitter, ElementRef, OnInit, AfterViewInit, ViewChild, runInInjectionContext } from "@angular/core";
import * as M from "materialize-css/dist/js/materialize";
import { SharedService } from "src/app/Services/sharedService";
import { ProjectService } from "src/app/Services/project.service";
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import * as _ from "lodash";
import { ConfirmationDialogComponent } from "src/app/confirmation-dialog/confirmation-dialog.component";
import { Observable, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { AddProjectComponent } from "../add-project/add-project.component";
import { ModalService } from "src/app/Services/modal.service";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { ActivatedRoute, Router } from "@angular/router";

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
  isreceive: boolean;
}

@Component({
    selector: "app-team-list",
    templateUrl: "./team-list.component.html",
    styleUrls: ["./team-list.component.css"],
    standalone: false
})

export class TeamListComponent implements OnInit, AfterViewInit {
  _userData: any;
  searchArr: any = [];
  @Input("isAdmin") isAdmin;
  @Input("loading") loading;
  @Output("goToList") goToTeam: EventEmitter<any> = new EventEmitter();
  @Input("selectedTeamData") selectedTeamData;
  errorPhotoShow: Boolean = false;
  skeletonLoader: Boolean = true;
  noDataFound: Boolean = false;
  _teamMembers: any;
  _usersList: any;
  selectedTeamManagers: any = [];
  selectedTeamDevelopers: any = [];
  selectedTeamLeaders: any = [];
  historyTabs: any = 0;
  _teamMemberListOnMode: any = [];
  usersRef: AngularFireList<User> = null;
  private dbPath: string | null = null;
  userDataSubscription: Subscription;
  currentTeamId;
  @Input()
  get groupList(): any {
    this.skeletonLoader = true;
    if (!this._userData) {
      this._userData = [];
      this.searchArr = [];
      this.noDataFound = true;
      this.skeletonLoader = false;
      this.errorPhotoShow = true;
      return this._userData;
    }
    return this._userData;
  }
  set groupList(data: any) {
    // 'selectedData' is encrypted in localStorage; always access via TokenEncryptionService.
    const selectedData = this.tokenEncryptionService.getEncryptedItem<any>('selectedData');
    if (selectedData) {
      this.selectedTeamData = selectedData;
    }

    if (data) {
      const transformedData = data?.map((team) => {
        team.membersFlag = this.getTotalMemberCount(team.meta);
        return team
      })
      console.log("This is transformed data", transformedData)
      this._userData = transformedData;
    } else {
      this._userData = [];
    }

    this.searchArr = this._userData

    if (!this.selectedTeamData) {
      this.goToTeam.emit(this._userData[0]);
    } else {
      this.goToTeam.emit(this.selectedTeamData);
    }
    if (!this._userData.length) {
      this._userData = [];
      this.searchArr = [];
      this.noDataFound = true;
      this.skeletonLoader = false;
      this.errorPhotoShow = true;
    }
    this.setStatus()
  }
  get teamData() {
    console.log("this._teamMembers", this._teamMembers)
    return this._teamMembers;
  }
  set teamData(team: any) {
    if (team) {
      if (!this._usersList) {
        this._projectService.getUserList(0, 0).subscribe((data) => {
          this.getEmployeeIdOnTeamSelect(team.meta, JSON.parse(JSON.stringify(data)) as any);
          this.onSelectUserMode({ index: this.historyTabs });
        });
      } else {
        this.getEmployeeIdOnTeamSelect(team.meta);
        this.onSelectUserMode({ index: this.historyTabs });
      }

      this._teamMembers = team;
    }
  }

  constructor(
    private _projectService: ProjectService,
    private _sharedService: SharedService,
    private db: AngularFireDatabase,
    private _messagingService: MessagingServiceService,
    private dialog: MatDialog,
    private _modalService: ModalService,
    private tokenEncryptionService: TokenEncryptionService,
    private injector: EnvironmentInjector,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('TeamList: dbPath updated to:', this.dbPath);
        // Re-initialize Firebase reference if needed
        if (this.usersRef) {
          this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
        }
        // Refresh status if we have team data
        if (this._teamMemberListOnMode && this._teamMemberListOnMode.length > 0) {
          this.setStatus();
        }
      }
    });

    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
  }

  ngOnInit() {

  }

  ngAfterViewInit(): void { }

  ngAfterContentInit(): void {
    // M.AutoInit();
  }

  goToTeamEmiter(team: any) {
    this.goToTeam.emit(team);
  }

  getTotalMemberCount(teamMembers: { team_developer: string, team_lead: string, team_manager: string }) {
    if (!teamMembers) {
      return `0 Member`;
    }

    const developer = teamMembers.team_developer;
    const lead = teamMembers.team_lead;
    const manager = teamMembers.team_manager;
    const allMembers = developer + lead + manager || "";
    if (allMembers.trim() === '' || allMembers === 'false') {
      return `0 Member`;
    }
    const uniqueNumbersSet = new Set(allMembers.match(/\d+/g).map(Number));
    const uniqueNumbersArray = [...uniqueNumbersSet];

    return uniqueNumbersArray.length > 1 ? `${uniqueNumbersArray.length} Members` : `${uniqueNumbersArray.length} Member`;
  }

  searchTeams(val: any) {
    let svalue = val.toUpperCase();
    this._userData = this.searchArr.filter((ele) => {
      return (ele.title.rendered.toUpperCase().includes(svalue));
    });

    if (this._userData.length <= 0) {
      this.errorPhotoShow = true;
      this.skeletonLoader = false;
    }
  }

  openTeamEditModal(teamId) {
    this._userData.find((team) => {
      if (team.id == teamId) {
        team.isMenuOpened = false;
      }
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { editTeam: teamId },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  getEmployeeIdOnTeamSelect(metaData: any, users?: any) {
    if (users) {
      this._usersList = users;
    }
    this.selectedTeamManagers = [];
    this.selectedTeamDevelopers = [];
    this.selectedTeamLeaders = [];
    let managers = metaData.team_manager
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");
    let developers = metaData.team_developer
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");
    let leaders = metaData.team_lead
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");

    let obj = {};
    obj["manager"] = managers;
    obj["developer"] = developers;
    obj["leaders"] = leaders;

    this.filteringData(this._usersList, obj);
  }

  filteringData(userList: any, data: any) {
    let onlyUsersId = [];
    let key;
    let uniqeId = [];
    let selectedUser = [];
    for (key in data) {
      data[key].map((ele) => {
        onlyUsersId.push(ele);
      });
    }
    uniqeId = Array.from(new Set(onlyUsersId));

    uniqeId.map((ele) => {
      userList.filter((userId) => {
        if (parseInt(ele) == parseInt(userId.id)) {
          selectedUser.push(userId);
        }
      });
    });

    for (key in data) {
      switch (key) {
        case "manager":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamManagers.push(element);
              }
            });
          });
          break;
        case "developer":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamDevelopers.push(element);
              }
            });
          });
          break;
        case "leaders":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamLeaders.push(element);
              }
            });
          });
          break;
      }
    }
  }

  onSelectUserMode(mode: any) {
    this.historyTabs = mode.index;
    switch (mode.index) {
      case 0:
        this._teamMemberListOnMode = this.selectedTeamManagers;
        this.setStatus();
        break;
      case 1:
        this._teamMemberListOnMode = this.selectedTeamLeaders;
        this.setStatus();
        break;
      case 2:
        this._teamMemberListOnMode = this.selectedTeamDevelopers;
        this.setStatus();
        break;
    }
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this._messagingService.resetData()
  }
  setStatus() {
    // Ensure dbPath exists before proceeding
    if (!this.dbPath) {
      console.warn('dbPath not set, cannot initialize Firebase reference');
      return;
    }

    this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));

    this.userDataSubscription = this._messagingService.getUserData().subscribe((users) => {
      users.forEach((o) => {
        if (this._teamMemberListOnMode) {
          let index = _.findIndex(
            this._teamMemberListOnMode,
            function (obj: any) {
              return obj.id == o.id;
            }
          );
          if (index > -1) {
            if (o.lastOnlineAtTz != null) {
              this._teamMemberListOnMode[index]["lastOnlineAtTz"] = o.lastOnlineAtTz;
            }
            if (o.lastOnlineAt != null) {
              this._teamMemberListOnMode[index]["lastOnlineAt"] = o.lastOnlineAt;
            }
            if (o.isIdle === true) {
              // Check for idle status from Firebase
              this._teamMemberListOnMode[index]["status"] = "idle";
            } else if (o.lastOnlineAtTz) {
              this._teamMemberListOnMode[index]["status"] = this._sharedService.getUserCurrentStatus(o.lastOnlineAtTz, true);
            } else if (!o.lastOnlineAtTz && o.lastOnlineAt) {
              this._teamMemberListOnMode[index]["status"] = this._sharedService.getUserCurrentStatus(o.lastOnlineAt, false);
            } else {
              this._teamMemberListOnMode[index]["status"] = "not-using";
            }

            // for application information about version and application type.
            if (o.appInfo) {
              if (o.appInfo.applicationType && o.appInfo.version) {
                o.appInfo.label = o.appInfo.applicationType.split("")[0].toUpperCase();
                o.appInfo.applicationType = o.appInfo.applicationType[0].toUpperCase() + o.appInfo.applicationType.slice(1);
                this._teamMemberListOnMode[index]["appInfo"] = o.appInfo;
              }
            } else {
              if (this._teamMemberListOnMode[index]["status"] != "not-using") {
                this._teamMemberListOnMode[index]["appInfo"] = { version: "4.1.2" }
              } else {
                this._teamMemberListOnMode[index]["appInfo"] = "";
              }
            }

            if (
              o.ssRequest != true &&
              o.ssRequest != false &&
              o.ssRequest != undefined &&
              o.ssRequest != null
            ) {
              this._teamMemberListOnMode[index]["ssRequest"] =
                o.ssRequest["createdAt"];
            }
          }
        }
      });
      this._teamMemberListOnMode.forEach((developer: any, index) => {
        if (!developer.appInfo) {
          developer.appInfo = "";
        }
      });
    });
  }

  deleteTeam(team) {
    let data = {
      id: team.id,
      type: "team",
      name: team.title.rendered
    };
    team.isMenuOpened = false;
    this.openDialog(ConfirmationDialogComponent, data).subscribe((response) => {
      if (response != undefined) {
        this._projectService.deleteTeam(data.id).subscribe((response: any) => {
          this.groupList.splice(_.findIndex(this.groupList, function (o) { return o.id == data.id }), 1);
          this._projectService.updateTeamDeletedData(response);
          this._projectService.refreshCurrentUser().subscribe();
        })
      }
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, { data, panelClass: 'centered-dialog' });
    return dialogRef.afterClosed();
  }

  openMenu(team) {
    this._userData.find((singleTeam) => {
      if (singleTeam.id != team.id) {
        singleTeam.isMenuOpened = false;
      }
    });
    if (team.isMenuOpened) {
      team.isMenuOpened = false;
    } else {
      team.isMenuOpened = true;
    }
    return team;
  }
}
